import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  class: "d-flex flex-row align-items-center justify-content-center",
  style: {"width":"120px","height":"120px"}
}
const _hoisted_3 = {
  style: {"width":"75px","text-align":"center"},
  class: "font-size-14"
}
const _hoisted_4 = { class: "margin-left-5" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "context-menu" }
const _hoisted_7 = { class: "context-menu-item" }
const _hoisted_8 = {
  class: "context-menu-item",
  "data-divider": "top"
}
const _hoisted_9 = {
  class: "context-menu-item",
  "data-divider": "top"
}
const _hoisted_10 = {
  key: 0,
  class: "context-menu-item",
  "data-divider": "top"
}
const _hoisted_11 = {
  key: 1,
  class: "context-menu-item",
  "data-divider": "top"
}
const _hoisted_12 = {
  class: "context-menu-item",
  "data-divider": "top"
}
const _hoisted_13 = {
  key: 2,
  class: "context-menu-item",
  "data-divider": "top"
}
const _hoisted_14 = {
  key: 3,
  class: "context-menu-item",
  "data-divider": "top"
}
const _hoisted_15 = {
  key: 4,
  class: "context-menu-item",
  "data-divider": "top"
}

import Draggable from "vuedraggable";
import {
  defineAsyncComponent,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";
import { cloneDeep } from "lodash-es";
import { v4 as uuidv4 } from "uuid";
import i18n from "@/core/i18n/i18n";
import { LoopItem } from "@/flow/services/flow.service";
import { useAddPositionToStep } from "../application/useAddPositionToStep";


export default /*#__PURE__*/_defineComponent({
  __name: 'StepContainer',
  props: {
    steps: {},
    drawerVisible: { type: Boolean },
    popUpOpen: { type: Boolean },
    stepLoading: { type: Boolean },
    selectedIndex: {},
    top: {},
    left: {},
    listIndex: {},
    selectedStep: {},
    clonedStep: {},
    paddingBottomForCentering: {}
  },
  emits: [
  "open-drawer",
  "context-menu",
  "remove-step",
  "show-condition",
  "insert-at-index",
  "close-drawer",
  "open-router",
  "list-changed",
  "update",
  "update-dragging",
  "open-delay",
  "open-filter",
  "insert-step-before",
  "clone-step",
  "open-output",
],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const StepBox = defineAsyncComponent(
  () => import("@/flow/components/StepBox.vue")
);
const RouterStepBox = defineAsyncComponent(
  () => import("@/flow/components/RouterStepBox.vue")
);

const props = __props;

const emit = __emit;

const dragOptions = ref({
  animation: 200,
  group: "description",
  disabled: false,
  ghostClass: "ghost",
  scrollSensitivity: 300,
  forceFallback: true,
  fallbackTolerance: 10,
  touchStartThreshold: 10,
});

const stepList = ref([]);

const contextMenuVisible = ref(false);

const contextMenuIndex = ref(-1);

const contextMenuTop = ref(0);

const contextMenuLeft = ref(0);

const contextMenuStep = ref(null);

const buttonIndex = ref(-1);

const buttonsVisible = ref(false);

const openedIndex = ref(-1);

const changedStep = ref({
  uniqueId: null,
  oldIndex: null,
  newIndex: null,
  step: null,
  id: null,
});

const loopList = ref([] as LoopItem[]);
function openDrawer(step, index, insideRouter, stepBoxRef) {
  openedIndex.value = index;
  emit("open-drawer", step, index, insideRouter, stepBoxRef);
  closeContextMenu();
}

function openRouterSettings(step, index, listIndex) {
  emit("open-router", step, index, listIndex);
  closeContextMenu();
}

function setButtonsVisible(index) {
  buttonIndex.value = index;
  buttonsVisible.value = true;
}

function setButtonsInvisible() {
  buttonIndex.value = -1;
  buttonsVisible.value = false;
}

function removeStep(index, step) {
  if (props.selectedIndex === index) {
    emit("close-drawer");
  }

  if (
    index === 0 &&
    stepList.value.filter((x) => x.type !== "ROUTER").length === 1
  ) {
    stepList.value = [
      {
        id: `new-step-${uuidv4()}`,
      },
    ];
  } else {
    stepList.value.splice(index, 1);
  }

  closeContextMenu();
  update({
    extra: {
      removedStep: {
        ix: step?.ix,
        id: step?.id,
        iy: step?.iy,
        step,
        uniqueId: step.uniqueId,
      },
    },
  });
}
function splitUniqueId(id) {
  return typeof id === "string" ? id.split("-") : id;
}
function updateUniqueId(stepUniqueId) {
  let updatedUniqueId;

  if (Array.isArray(stepUniqueId)) {
    const lastIndex = stepUniqueId.length - 1;
    const updatedId = (parseInt(stepUniqueId[lastIndex], 10) + 1).toString();

    stepUniqueId[lastIndex] = updatedId;
    updatedUniqueId = stepUniqueId.join("-");
  } else {
    updatedUniqueId = (parseInt(stepUniqueId, 10) + 1).toString();
  }

  return updatedUniqueId;
}
function insertAtIndex(index, ix, iy) {
  const step = {
    id: `new-step-${uuidv4()}`,
    ix,
  };
  if (index === stepList.value.length) {
    stepList.value.push(step);
  } else {
    stepList.value.splice(index, 0, step);
  }
  const beforeStep = stepList.value[index - 1];
  let stepUniqueId = splitUniqueId(beforeStep.uniqueId);
  stepUniqueId = updateUniqueId(stepUniqueId);
  stepUniqueId =
    stepUniqueId.length > 1 ? stepUniqueId : parseInt(stepUniqueId, 10);
  closeContextMenu();
  update({
    extra: {
      addedStep: {
        ix,
        iy,
        id: step.id,
        uniqueId: stepUniqueId,
      },
    },
  });
}

function insertStepBefore(index, afterStep) {
  const step = {
    id: `new-step-${uuidv4()}`,
  };
  stepList.value.splice(index, 0, step);
  closeContextMenu();
  update({
    extra: {
      addedStep: {
        ix: afterStep.ix,
        iy: afterStep.iy,
        id: step.id,
        uniqueId: afterStep.uniqueId,
      },
    },
  });
}

function checkMove(evt) {
  const isLastItemRouter =
    stepList.value[stepList.value.length - 1].type !== undefined;
  const isFirstItemWebhook =
    stepList.value[0].connectorSpecId &&
    stepList.value[0].connectorSpecId.includes("webhook");
  let dontAllowLast = true;
  if (isLastItemRouter) {
    dontAllowLast =
      evt.draggedContext.futureIndex !== stepList.value.length - 1;
  }
  if (isFirstItemWebhook && evt.draggedContext.futureIndex === 0) {
    dontAllowLast = false;
  }
  return evt.from === evt.to && dontAllowLast;
}

function onDragStart() {
  emit("update-dragging", { stopPropagation: true });
}

function onDragEnd() {
  emit("update-dragging", { stopPropagation: false });
  update({ extra: { changedStep: changedStep.value }, onlyLineUpdate: true });
}

function contextMenuEvt(event, index, step) {
  event.preventDefault();
  if (contextMenuVisible.value) {
    closeContextMenu();
  } else {
    contextMenuLeft.value = event.x;
    contextMenuTop.value = event.y;
    contextMenuIndex.value = index;
    contextMenuStep.value = step;
    contextMenuVisible.value = true;
  }
}

function listChanged(evt) {
  emit("list-changed", evt, stepList.value);
  const diff = evt.moved.oldIndex - evt.moved.newIndex;
  changedStep.value = {
    oldIndex: evt.moved.element.ix,
    newIndex: evt.moved.element.ix - diff,
    step: evt.moved.element,
    uniqueId: evt.moved.element.uniqueId,
    id: evt.moved.element.id,
  };
  update({
    extra: {
      changedStep: changedStep.value,
    },
  });
}

function closeContextMenu() {
  contextMenuVisible.value = false;
  contextMenuIndex.value = -1;
  contextMenuStep.value = null;
}

function openFilter(index, step) {
  emit("show-condition", index, step);
  closeContextMenu();
}

function addOrRemoveExpressionType(step, type, index) {
  if (checkForLoopAndEndByType(type, step)) {
    step.translations = step.translations.filter(
      (item) => item.expressionType !== type
    );
    const loopItem = loopList.value.find((item) =>
      type === "LOOP" ? item.startIdx === index : item.endIdx === index
    );
    if (loopItem) {
      const endStep = stepList.value.find(
        (stepItem) =>
          stepItem.ix ===
          (type === "LOOP" ? loopItem.endIdx : loopItem.startIdx)
      );
      if (endStep) {
        endStep.translations = endStep.translations.filter(
          (item) => item.expressionType !== (type === "LOOP" ? "END" : "LOOP")
        );
        stepList.value.splice(
          type === "LOOP" ? loopItem.endIdx : loopItem.startIdx,
          1,
          endStep
        );
      }
    }
  } else {
    step.translations.push({ expressionType: type });
  }
  update();
  closeContextMenu();
}

function checkForLoopAndEndByType(type, step) {
  let contains = false;
  if (step.translations) {
    step.translations.forEach((item) => {
      if (item.expressionType && item.expressionType === type) {
        contains = true;
      }
    });
  }
  return contains;
}

function addRouter() {
  if (contextMenuIndex.value === stepList.value.length - 1) {
    stepList.value.push({
      id: uuidv4(),
      type: "ROUTER",
      routes: [
        {
          steps: [{ id: `new-step-${uuidv4()}` }],
          name: "Condition 1",
          filter: null,
        },
      ],
    });
  } else if (stepList.value[contextMenuIndex.value + 1].type === "ROUTER") {
    // prevent secondary router addition
    closeContextMenu();
    return;
  } else {
    const parsedList = stepList.value.slice(
      contextMenuIndex.value + 1,
      stepList.value.length
    );
    stepList.value = stepList.value.slice(0, contextMenuIndex.value + 1);
    stepList.value.push({
      id: uuidv4(),
      type: "ROUTER",
      routes: [
        {
          steps: parsedList,
          name: "Condition 1",
          filter: null,
        },
      ],
    });
  }
  update();
  closeContextMenu();
}

function addDelay(index, step) {
  emit("open-delay", index, step);
  closeContextMenu();
}

function addFilter(index, step) {
  emit("open-filter", index, step);
  closeContextMenu();
}

function openOutput(index, step) {
  emit("open-output", index, step);
  closeContextMenu();
}

function removeRoute(step, childIndex, parentIndex) {
  if (step.routes.length === 1) {
    removeStep(parentIndex, step);
  } else {
    step.routes.splice(childIndex, 1);
  }
  closeContextMenu();
  update();
}
function updateExtraStepInfo(steps) {
  steps.forEach((step) => {
    if (!step.type) {
      if (step.id === changedStep.value.id) {
        changedStep.value.uniqueId = step.uniqueId;
      }
    } else {
      step.routes.forEach((route) => {
        updateExtraStepInfo(route.steps);
      });
    }
    return step;
  });
}
function updateStepList({ list, extra }, stepId, index) {
  const idx = stepList.value.findIndex((item) => item.id === stepId);
  const step = stepList.value[idx];
  if (step) {
    step.routes[index].steps = list;
    stepList.value.splice(idx, 1, step);
  }
  stepList.value = useAddPositionToStep(cloneDeep(stepList.value));
  if (changedStep.value.uniqueId !== null && extra && extra.changedStep) {
    updateExtraStepInfo(stepList.value);
    extra.changedStep = { ...changedStep.value };
  }
  update({ extra });
}

function update(
  {
    list = stepList.value,
    extra = null,
    onlyLineUpdate = false,
  }: { list?: any; extra?: any; onlyLineUpdate?: boolean } = {
    list: stepList.value,
    extra: null,
    onlyLineUpdate: false,
  }
) {
  emit("update", {
    list,
    extra,
    onlyLineUpdate,
  });
}

watch(
  () => props.steps,
  () => {
    stepList.value = cloneDeep(props.steps);
  },
  // TODO future performance optimization point,
  //  handle "deep" in an optimized way to reduce step container re-renders
  { deep: true, immediate: true }
);

watch(
  () => props.selectedIndex,
  () => {
    if (props.selectedIndex < 0) {
      openedIndex.value = props.selectedIndex;
    }
  }
);

function isWebHook(step) {
  return step.connectorSpecId && step.connectorSpecId.includes("webhook");
}

function cloneStep(step) {
  emit("clone-step", step);
  closeContextMenu();
}
function pasteStep() {
  const newStep = {
    ...props.clonedStep,
    id: `new-step-${uuidv4()}`,
    origId: uuidv4(),
  };
  stepList.value.splice(contextMenuIndex.value + 1, 0, newStep);
  const copiedItemIndex = stepList.value.findIndex(
    (item) => item.id === newStep.id
  );
  const item = stepList.value[copiedItemIndex - 1];
  newStep.ix = item.ix !== undefined ? item.ix + 1 : newStep.ix;
  newStep.iy = item.iy !== undefined ? item.iy : newStep.ix;
  newStep.parentId = undefined;
  let stepUniqueId = splitUniqueId(item.uniqueId);
  stepUniqueId = updateUniqueId(stepUniqueId);
  stepUniqueId =
    stepUniqueId.length > 1 ? stepUniqueId : parseInt(stepUniqueId, 10);
  newStep.uniqueId = stepUniqueId;
  update({ extra: { addedStep: newStep } });
  closeContextMenu();
  emit("clone-step", undefined);
}

const contextMenuRef = ref();
const outSideClick = (event) => {
  if (
    contextMenuRef?.value !== event.target &&
    !contextMenuRef?.value?.contains(event.target)
  ) {
    closeContextMenu();
  }
};
onMounted(() => {
  document.addEventListener("click", outSideClick);
});
onBeforeUnmount(() => {
  document.removeEventListener("click", outSideClick);
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_StepContainer = _resolveComponent("StepContainer", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "step-container",
      onClick: closeContextMenu,
      style: _normalizeStyle([{"position":"relative"}, {
      top: `${_ctx.top}px`,
      left: `${_ctx.left}px`,
      paddingBottom: props.paddingBottomForCentering,
    }])
    }, [
      _createVNode(_unref(Draggable), _mergeProps({
        id: `step-route-container${_ctx.listIndex}`,
        class: "d-grid flex-row draggable-container",
        modelValue: stepList.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((stepList).value = $event)),
        move: checkMove,
        handle: ".handle",
        "item-key": "id",
        onChange: listChanged,
        onEnd: onDragEnd,
        onStart: onDragStart
      }, dragOptions.value, {
        style: `grid-template-columns:repeat(${stepList.value.length}, 210px [col-start])`
      }), {
        item: _withCtx(({ element: step, index }) => [
          _createElementVNode("div", null, [
            (!step.type)
              ? (_openBlock(), _createBlock(_unref(StepBox), {
                  key: 0,
                  step: step,
                  index: index,
                  "drawer-visible": _ctx.drawerVisible,
                  "selected-index": openedIndex.value,
                  "selected-step": _ctx.selectedStep,
                  "list-index": _ctx.listIndex,
                  "pop-up-open": _ctx.popUpOpen,
                  "step-loading": _ctx.stepLoading,
                  "buttons-visible": buttonsVisible.value,
                  "filter-available": index !== _ctx.steps.length - 1,
                  "button-index": buttonIndex.value,
                  onOpenDrawer: openDrawer,
                  onOpenDelay: addDelay,
                  onOpenFilter: addFilter,
                  onContextmenu: ($event: any) => (contextMenuEvt($event, index, step)),
                  onSetButtonVisible: setButtonsVisible,
                  onSetButtonInvisible: setButtonsInvisible,
                  type: "step",
                  onRemoveStep: removeStep,
                  onInsertAtIndex: insertAtIndex,
                  onInsertStepBefore: insertStepBefore,
                  onOpenOutput: openOutput
                }, null, 8, ["step", "index", "drawer-visible", "selected-index", "selected-step", "list-index", "pop-up-open", "step-loading", "buttons-visible", "filter-available", "button-index", "onContextmenu"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_unref(RouterStepBox), {
                    "list-index": _ctx.listIndex,
                    step: step,
                    index: index,
                    openRouterSettings: openRouterSettings,
                    onInsertAtIndex: insertAtIndex
                  }, null, 8, ["list-index", "step", "index"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.routes, (route, routeIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: route,
                      class: "d-flex flex-row",
                      style: _normalizeStyle(`position: relative;left: -120px; top:${
                step.afterRouteCount * 200
              }px`)
                    }, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(route.name), 1),
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("button", {
                            class: "btn btn-link",
                            onClick: ($event: any) => (removeRoute(step, routeIndex, index))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ], 8, _hoisted_5)
                        ])
                      ]),
                      _createVNode(_component_StepContainer, {
                        steps: route.steps,
                        left: 0,
                        top: 0,
                        "drawer-visible": _ctx.drawerVisible,
                        "selected-index": openedIndex.value,
                        "pop-up-open": _ctx.popUpOpen,
                        "step-loading": _ctx.stepLoading,
                        "list-index": `${_ctx.listIndex}-${routeIndex.toString()}`,
                        "selected-step": _ctx.selectedStep,
                        "cloned-step": _ctx.clonedStep,
                        onUpdateDragging: _cache[0] || (_cache[0] = ($event: any) => (emit('update-dragging', $event))),
                        onUpdate: ($event: any) => (updateStepList($event, step.id, routeIndex)),
                        onOpenDrawer: openDrawer,
                        onContextMenu: contextMenuEvt,
                        onOpenDelay: addDelay,
                        onOpenFilter: addFilter,
                        onShowCondition: openFilter,
                        onListChanged: listChanged,
                        onRemoveStep: ($event: any) => (removeStep($event, step)),
                        onOpenRouter: openRouterSettings,
                        onInsertAtIndex: insertAtIndex,
                        onCloneStep: cloneStep,
                        onOpenOutput: openOutput
                      }, null, 8, ["steps", "drawer-visible", "selected-index", "pop-up-open", "step-loading", "list-index", "selected-step", "cloned-step", "onUpdate", "onRemoveStep"])
                    ], 4))
                  }), 128))
                ]))
          ])
        ]),
        _: 1
      }, 16, ["id", "modelValue", "style"])
    ], 4),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (contextMenuVisible.value && contextMenuIndex.value > -1 && contextMenuStep.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "contextMenuRef",
            ref: contextMenuRef,
            class: "context-menu-div",
            style: _normalizeStyle({ top: `${contextMenuTop.value}px`, left: `${contextMenuLeft.value}px` }),
            onMousedown: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
            onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("a", {
                  class: "context-menu-a",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (
              insertAtIndex(
                contextMenuIndex.value + 1,
                contextMenuStep.value?.ix,
                contextMenuStep.value?.iy
              )
            ))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "margin-right-10 fa-fw",
                    icon: "plus"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)("Common.AddNew")), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createElementVNode("a", {
                  class: "context-menu-a",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (openFilter(contextMenuIndex.value, contextMenuStep.value)))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "margin-right-10 fa-fw",
                    icon: "filter"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)("Common.Filter")), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("a", {
                  class: "context-menu-a",
                  onClick: addRouter
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "margin-right-10 fa-fw",
                    icon: "code-branch"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)("Common.AddRouter")), 1)
                ])
              ]),
              (!checkForLoopAndEndByType('LOOP', contextMenuStep.value))
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _createElementVNode("a", {
                      class: "context-menu-a",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (
              addOrRemoveExpressionType(
                contextMenuStep.value,
                'LOOP',
                contextMenuIndex.value
              )
            ))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "redo",
                        class: "margin-right-10 fa-fw"
                      }),
                      _createTextVNode(" " + _toDisplayString(_unref(t)("Common.Loop")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!checkForLoopAndEndByType('END', contextMenuStep.value))
                ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                    _createElementVNode("a", {
                      class: "context-menu-a",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (
              addOrRemoveExpressionType(
                contextMenuStep.value,
                'END',
                contextMenuIndex.value
              )
            ))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "redo",
                        class: "margin-right-10 fa-fw"
                      }),
                      _createTextVNode(" " + _toDisplayString(_unref(t)("Common.End")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_12, [
                _createElementVNode("a", {
                  class: "context-menu-a",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (addDelay(contextMenuIndex.value, contextMenuStep.value)))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "margin-right-10 fa-fw",
                    icon: "hourglass-start"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)("Common.Delay")), 1)
                ])
              ]),
              (!isWebHook(contextMenuStep.value))
                ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                    _createElementVNode("a", {
                      class: "context-menu-a",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (cloneStep(contextMenuStep.value)))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "margin-right-10 fa-fw",
                        icon: "clone"
                      }),
                      _createTextVNode(" " + _toDisplayString(_unref(t)("Flow.CloneStep")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.clonedStep)
                ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                    _createElementVNode("a", {
                      class: "context-menu-a",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (pasteStep(contextMenuStep.value)))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "margin-right-10 fa-fw",
                        icon: "clone"
                      }),
                      _createTextVNode(" " + _toDisplayString(_unref(t)("Flow.PasteStep")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (contextMenuIndex.value > 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                    _createElementVNode("a", {
                      class: "context-menu-a",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (removeStep(contextMenuIndex.value, contextMenuStep.value.value)))
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "margin-right-10 fa-fw",
                        icon: "times"
                      }),
                      _createTextVNode(" " + _toDisplayString(_unref(t)("Common.Remove")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 36))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})